export enum CommercialRealEstateType {
  OFFICE = 'OFFICE',
  HALL = 'HALL',
  RETAIL = 'RETAIL',
  GASTRONOMY = 'GASTRONOMY',
  MISCELLANEOUS = 'MISCELLANEOUS',
}
